import { useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useApi = () => {
  const { token, logout } = useAuth();

  const api = useCallback(async (method, endpoint, data = null) => {
    try {
      const config = {
        method,
        url: `${API}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` })
        },
        ...(data && { data })
      };

      const response = await axios(config);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
      }
      throw error;
    }
  }, [token, logout]);

  const get = useCallback((endpoint) => api('GET', endpoint), [api]);
  const post = useCallback((endpoint, data) => api('POST', endpoint, data), [api]);
  const put = useCallback((endpoint, data) => api('PUT', endpoint, data), [api]);
  const patch = useCallback((endpoint, data) => api('PATCH', endpoint, data), [api]);
  const del = useCallback((endpoint) => api('DELETE', endpoint), [api]);

  return { get, post, put, patch, del };
};
